import { Model } from 'json-api-models';

import { Models, Schemas } from '../models.ts';
import { nullableDate } from '../utils/format.ts';
import { User } from './user.ts';

export class Feedback extends Model<Schemas['feedback'], Models> {
    get displayUser() {
        const user = this.user?.name ? this.user : undefined;

        if (!this.userDetails) {
            return user;
        }

        const displayUser = new User(
            {
                type: 'users',
                id: '',
                ...this.user?.identifier(),
                attributes: {
                    ...this.user?.attributes,
                    ...this.userDetails,
                },
            },
            this.store,
        );

        return displayUser.name ? displayUser : user;
    }

    get createdAtDate() {
        return nullableDate(this.createdAt);
    }

    get updatedAtDate() {
        return nullableDate(this.updatedAt);
    }

    get respondedAtDate() {
        return nullableDate(this.respondedAt);
    }
}
